export default "__VITE_ASSET__D3NGH7dn__"